// Generated by purs version 0.13.0
"use strict";
var Data_Array_NonEmpty = require("../Data.Array.NonEmpty/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var pickInRepository = function (v) {
    var find = function ($copy_i) {
        return function ($copy_n) {
            var $tco_var_i = $copy_i;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(i, n) {
                var v1 = Data_Array_NonEmpty.index(v.options)(i);
                if (v1 instanceof Data_Maybe.Nothing) {
                    $tco_done = true;
                    return (Data_Array_NonEmpty.head(v.options)).value;
                };
                if (v1 instanceof Data_Maybe.Just && v1.value0.chance > n) {
                    $tco_done = true;
                    return v1.value0.value;
                };
                if (v1 instanceof Data_Maybe.Just) {
                    $tco_var_i = i + 1 | 0;
                    $copy_n = n - v1.value0.chance | 0;
                    return;
                };
                throw new Error("Failed pattern match at Ritoppu.Model.Repository (line 29, column 14 - line 32, column 49): " + [ v1.constructor.name ]);
            };
            while (!$tco_done) {
                $tco_result = $tco_loop($tco_var_i, $copy_n);
            };
            return $tco_result;
        };
    };
    return find(0);
};
var initRepository = function (chance) {
    return function (value) {
        return {
            total: chance,
            options: Data_Array_NonEmpty.singleton({
                chance: chance,
                value: value
            })
        };
    };
};
module.exports = {
    initRepository: initRepository,
    pickInRepository: pickInRepository
};
